import React, { Component } from 'react';
// import Wrp from '../Wrp/Wrp';
import Modal from "react-bootstrap/Modal";

class ConfirmBox extends Component {
    state = {}

    render () {
        const {
            isConfirmBoxOpen,
            content,
            toggleConfirmBox,
            confirmButtonClick,
            zIndex = 1060,
            modalClassName = '',
            backdropClassName = '',
        } = this.props;
        return (
            <Modal
                size="md"
                show={isConfirmBoxOpen}
                dialogClassName="modal-dialog modal-xs height-auto animated fadeInDown"
                className={modalClassName}
                backdropClassName={backdropClassName}
                style={{ zIndex }}
            >
                <Modal.Header className="p-2">
                    <h4 className="modal-title secondary_color pl-2 mb-0"> Confirmation </h4>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                          {isConfirmBoxOpen && <div className="swal-text">{content && content !== "" ? content : "You won't be able to revert this!"  }</div>}
                        </div> 
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    
                    <a href='#!' onClick={toggleConfirmBox} className="btn btn-border border-default mr-2"> Cancel </a>    
                    <a href='#!' onClick={confirmButtonClick} tabIndex={1} className="btn primary_bg"> Confirm{/*, delete it!*/} </a> 
                     
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ConfirmBox;